// extracted by mini-css-extract-plugin
export default {"addService":"styles_addService__Agm0f","plus":"styles_plus__cRGGt"};